export const maintenanceTemplate = {
  notPlanned: { label: "New", detailLabel: "New" },
  inProgress: { label: "In Progress" },
  planned: { label: "Planned" },
  complete: { label: "Complete" },
  closed: { label: "Closed" },
  planning: { label: "Planning" },
  open: { label: "Open" },
  review: { label: "Pending Review" },
  returned: { label: "Returned" },
};



// WEBPACK FOOTER //
// ./src/templates/MaintenanceTemplate.js